import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "Información diversa",
  "lead": "Lead text"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    hr: "hr",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {Aside, FederalMinistryGermanyLogo, LinkBlock, Title} = _components;
  if (!Aside) _missingMdxReference("Aside", true);
  if (!FederalMinistryGermanyLogo) _missingMdxReference("FederalMinistryGermanyLogo", true);
  if (!LinkBlock) _missingMdxReference("LinkBlock", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: "Información diversa"
    }), "\n", _jsx(_components.h2, {
      id: "scope",
      children: "SCOPE"
    }), "\n", _jsx(_components.p, {
      children: "La herramienta del Progreso de la educación (SCOPE) reúne datos administrativos, encuestas de hogares, evaluaciones del aprendizaje y datos de la financiación de la educación de diversos productores de datos, en particular el Instituto de Estadística de la UNESCO, a fin de analizar los progresos realizados para lograr el ODS 4, el objetivo mundial relativo a la educación."
    }), "\n", _jsxs(_components.p, {
      children: ["Completa la ", _jsx(_components.a, {
        href: "https://es.unesco.org/gem-report/allreports",
        children: "edición impresa"
      }), " del Informe de Seguimiento de la Educación en el Mundo, permitiendo a los usuarios interactuar con los datos para comprender los logros y los desafíos de los países y las regiones en su empeño por alcanzar las metas. Puede compartirse y descargarse, y permite a sus usuarios crear imágenes y archivos de datos para profundizar sus conocimientos, que podrán imprimir o utilizar en línea o en exposiciones."]
    }), "\n", _jsx(_components.h2, {
      id: "informe-de-seguimiento-de-la-educación-en-el-mundo",
      children: "Informe de Seguimiento de la Educación en el Mundo"
    }), "\n", _jsxs(_components.p, {
      children: ["El Informe de Seguimiento de la Educación en el Mundo es una publicación anual independiente editorialmente, acogida y publicada por la UNESCO. De acuerdo con el ", _jsx(_components.a, {
        href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656_spa",
        children: "Marco de Acción Educación 2030"
      }), ", tiene el mandato de supervisar los progresos de la educación en pro de los ODS, y los de la aplicación de estrategias educativas nacionales e internacionales para ayudar a todos los asociados pertinentes a dar cuenta acerca de sus compromisos."]
    }), "\n", _jsx(LinkBlock, {
      title: "Visite el sitio web",
      url: "https://es.unesco.org/gem-report/",
      variant: "gem"
    }), "\n", _jsx(_components.h2, {
      id: "el-objetivo-de-desarrollo-sostenible-4",
      children: "El Objetivo de Desarrollo Sostenible 4"
    }), "\n", _jsxs(_components.p, {
      children: ["En septiembre de 2015, en la Cumbre de Desarrollo Sostenible de las Naciones Unidas celebrada en Nueva York, los Estados Miembros adoptaron oficialmente la ", _jsx(_components.a, {
        href: "https://sustainabledevelopment.un.org/post2015/transformingourworld",
        children: "Agenda 2030 para el Desarrollo Sostenible"
      }), ". La Agenda tiene 17 objetivos, uno de los cuales, el ODS 4, consiste en \"garantizar una educación inclusiva y equitativa de calidad y promover oportunidades de aprendizaje permanente para todos\". El ODS 4 tiene siete metas y tres medios de aplicación."]
    }), "\n", _jsx(LinkBlock, {
      title: "Vea las metas y los marcos de seguimiento conexos",
      url: "https://sustainabledevelopment.un.org/sdg4",
      variant: "sdg4"
    }), "\n", _jsx(FederalMinistryGermanyLogo, {
      lang: "en"
    }), "\n", _jsx(_components.p, {
      children: "Agradecemos especialmente al Ministerio Federal de Educación e Investigación de Alemania su colaboración y su generosa contribución para elaborar el sitio web sobre el Progreso de la educación."
    }), "\n", _jsxs(Aside, {
      children: [_jsx(_components.h2, {
        id: "correo-electrónico-general",
        children: "Correo electrónico general"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Correo electrónico general"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "mailto:gemreport@unesco.org",
          children: "gemreport@unesco.org"
        })
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "El Equipo"
      }), _jsx(_components.p, {
        children: "Equipo del Informe GEM, UNESCO"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Dirección"
      }), _jsx(_components.p, {
        children: "Global Education Monitoring Report Team (GEM Report),\nUNESCO, 7 place de Fontenoy, 75352 Paris 07 SP, France"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
